import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">
          <div>
            <div className="footer__logo">Hormone<em>ly</em></div>
            <p className="footer__tagline">Hormone health, by decade. Plain English information for men and women in their 40s, 50s and beyond.</p>
          </div>
          <div className="footer__links">
            <Link to="/women" className="footer__link">Women</Link>
            <Link to="/men" className="footer__link">Men</Link>
            <Link to="/symptoms" className="footer__link">Symptoms</Link>
            <Link to="/blood-tests" className="footer__link">Blood Tests</Link>
            <Link to="/stacks" className="footer__link">Stacks</Link>
            <Link to="/about" className="footer__link">About</Link>
          </div>
          <div>
            <p className="footer__disclaimer">
              This site provides information only. It is not medical advice and does not replace a consultation with your GP or a qualified health professional. Always speak to a doctor before making changes to your health, starting supplements, or pursuing hormone treatment.
            </p>
          </div>
        </div>
        <div className="footer__bottom">
          <span className="footer__copy">&copy; {new Date().getFullYear()} Hormonely. All rights reserved.</span>
          <div style={{ display: 'flex', gap: '20px' }}>
            <Link to="/privacy" className="footer__link">Privacy</Link>
            <Link to="/terms" className="footer__link">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
